import React, { Component } from "react";
import ReactDOM from "react-dom";

//API CALL - https://restcountries.eu/rest/v2/name/{name}

class FormComponent extends Component {
  state = {
    value: ""
  };

  render() {
    return (
      <React.Fragment>
        <form
          onSubmit={event => {
            let trimmed = this.state.value.trim();
            if (trimmed != "") {
              this.props.onSubmit(event, this.state.value);
            }
            this.clearForm();
          }}
          className="m-2"
        >
          <div className="container">
            <div className="form-group m-4">
              <input
                onChange={event => {
                  this.handleChange(event);
                  let trimmed = this.state.value.trim();
                  if (trimmed != "") {
                    this.props.onSubmit(event, this.state.value);
                  }
                }}
                type="text"
                className="form-control"
                id="transactionField"
                value={this.state.value}
                placeholder="Enter country"
              />
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }

  clearForm() {
    this.state.value = "";
    this.setState({});
  }

  handleChange = event => {
    this.state.value = event.target.value;
    this.setState({});
  };
}

export default FormComponent;
